// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"296":"681143be","608":"681143be","664":"681143be","834":"681143be"}[chunkId] + ".css";
};